import React from 'react';
import {
  Form, Row, Col,  Button, DatePicker,
} from 'antd';
import img from './../../assets/img/Illustration.png';
class FD extends React.Component {
constructor(props){
super(props)
this.state={
}
}
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {

          this.props.submitHandler({ ...values,id:this.props.id},true,(val)=>{
            if(!val){
            }
          });

      }
    });
  }

  render() {
    const { getFieldDecorator,getFieldValue } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className='mi_title'>{this.props.title}</p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>

          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Termination Date</legend>
                  {getFieldDecorator('termination_date', {
                    rules: [{ required: true, message: 'Please select termination date' },
                    // {
                    //   validator(rule, value) {
                    //     if (!value || getFieldValue('renewal_date') > value) {
                    //       return Promise.resolve();
                    //     }
                    //     return Promise.reject('Termination date must be greater than Renewal date');
                    //   }
                    // }
                  ],
                  })(
                    <DatePicker autoComplete={"nope"}  format="MM/DD/YYYY" className="mi_input" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Renewal Date</legend>
                  {getFieldDecorator('renewal_date', {
                    rules: [{ required: true, message: 'Please select renewal date' },
                    // {
                    //   validator(rule, value) {
                    //     if (!value ||   getFieldValue('termination_date') < value ) {
                    //       return Promise.resolve();
                    //     }
                    //     return Promise.reject('Renewal date must be less than Termination date');
                    //   }
                    // }
                  ],
                  })(
                    <DatePicker autoComplete={"nope"}  format="MM/DD/YYYY" className="mi_input" />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>

          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7}></Col>
            <Col span={5}>
              <Button className="mi_button_right" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Cancel
                      </Button>
            </Col>
            <Col span={5}>
              <Button htmlType="submit" type="primary" >
                Submit
                  </Button>
            </Col>
            <Col span={7}>
              <img alt="example" style={{ width: 105, marginBottom: '-26px', float: 'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const ApproveDocumentDrawer = Form.create()(FD);
export default ApproveDocumentDrawer;